import { render, staticRenderFns } from "./AnatomiasFisiologiasFormulario.vue?vue&type=template&id=d7824546"
import script from "./AnatomiasFisiologiasFormulario.vue?vue&type=script&lang=js"
export * from "./AnatomiasFisiologiasFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports